import { Maybe } from "src/generated/graphqlTypes";
import {
  BidPackageDetailActiveRequestFragment,
  BidPackageDetailPage_BidContractRevisionFragment,
  PageBidPackageDetailFragment,
} from "src/routes/bids/BidPackageDetailPage.generated";

export function getBidPackageTradesWithEstimate(bp: {
  isInternalEstimate: boolean;
  internalEstimateBidContract?: Maybe<{ id: string }>;
  activeRequests: BidPackageDetailActiveRequestFragment[];
  latestVersion: { latestBidContractRevisions: BidPackageDetailPage_BidContractRevisionFragment[] };
}) {
  if (bp.isInternalEstimate) {
    return [
      {
        id: "hbr",
        tradePartner: { id: "hb", name: "Homebound" },
        bidContract: bp.internalEstimateBidContract,
        bidContractRevision: bp.latestVersion.latestBidContractRevisions.first,
      },
    ];
  }
  return bp.activeRequests.map((request) => ({
    ...request,
    bidContractRevision: bp.latestVersion.latestBidContractRevisions.find(
      (bcr) => bcr.bidContract.tradePartner?.id === request.tradePartner.id,
    ),
  }));
}

/** Expensive (# of JSON fields returned) cost codes that use a degraded PBBv1 scope-lines query (see P-2396). */
const HEAVY_SCOPE_COST_CODE_NUMBERS = new Set([
  "5001", // Pre-Fab Cabinets
]);
export function isHeavyScopeBidPackage(bidPackage: PageBidPackageDetailFragment) {
  return bidPackage.costCodes.some((costCode) => HEAVY_SCOPE_COST_CODE_NUMBERS.has(costCode.number));
}
